// Note: Decreasing this number can break the app for users with many tasks
export const TEMPLATE_TASK_LIMIT = 500;

export const GROUP_PREFIX = 'group:';

export const MAX_TEMPLATE_NAME_LENGTH = 60;
